export default {
    START: "onMediaStart",
    STOP: "onMediaStop",
    STREAM_START: "onStreamStart",
    STREAM_STOP: "onStreamStop",
}
